import { forwardRef } from "react";
import { useTranslation } from "react-i18next";
import Input from "@/components/ui/input";
import { MAX_REPORT_NAME_LENGTH } from "@/components/global/Chat/components/dreamerReports/useReportRename";
import { TRANSLATION_KEY } from "@/components/global/Chat/components/dreamerReports/consts";

interface ReportNameInputProps {
  value: string;
  onValueChange: (value: string) => void;
  onCommit: () => void;
  onCancel: () => void;
}

/** The inline rename field, identical wherever a report name can be edited. */
export const ReportNameInput = forwardRef<HTMLInputElement, ReportNameInputProps>(
  ({ value, onValueChange, onCommit, onCancel }, ref) => {
    const { t } = useTranslation();

    return (
      <Input
        ref={ref}
        value={value}
        maxLength={MAX_REPORT_NAME_LENGTH}
        placeholder={t(`${TRANSLATION_KEY}.rename.placeholder`)}
        onChange={(event) => onValueChange(event.target.value)}
        onBlur={onCommit}
        onKeyDown={(event) => {
          // Enter while an IME candidate window is open confirms the
          // candidate, not the rename.
          if (event.nativeEvent.isComposing) return;
          if (event.key === "Enter") onCommit();
          if (event.key === "Escape") onCancel();
        }}
        data-test="report-rename-input"
      />
    );
  }
);

ReportNameInput.displayName = "ReportNameInput";
